module.exports = __webpack_public_path__ + "img/20210117_105100.7dd44c23.jpg";